import { AnalyticsRequest } from '@sprinklr/stories/analytics/AnalyticsRequest';
import { SpaceRequest } from '@sprinklr/stories/reporting/types';

export function getProjectionOrigOrderFromRequest(
    request: SpaceRequest,
    origRequest: AnalyticsRequest
): number[] {
    // origOrder is lost for projectionDecorations, so we need to find the origOrder from the original request
    if (request.projectionDecorations?.length > 0) {
        return request.projectionDecorations.map(projection => {
            return origRequest.projections.findIndex(proj => projection === proj.aggregateFunction);
        });
    }
    // account for projection nested in groupBy
    const orderAdditionalGroupBy = request.groupBys?.[0]?.projections.map(projection => {
        return projection.details.origOrder;
    });

    const orderAdditional = request.projections?.map(projection => {
        return projection.details.origOrder;
    });

    return orderAdditionalGroupBy?.length > 0 ? orderAdditionalGroupBy : orderAdditional;
}
